const wd = require('./components');

const req = require.context('./components', true, /^\.\/locale\/.+_.+\.tsx$/);

wd.locales = {};

req.keys().forEach(mod => {
  const matches = mod.match(/\/([^/]+).tsx$/);
  wd.locales[matches[1]] = req(mod).default;
});

module.exports = wd;
